import { render, staticRenderFns } from "./analyticsInventoryDashboard.vue?vue&type=template&id=5e4cb5aa&"
import script from "./analyticsInventoryDashboard.vue?vue&type=script&lang=js&"
export * from "./analyticsInventoryDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports